import * as React from 'react';
import { Flex, Button } from '@chakra-ui/react';

interface Props {
  complete: boolean;
  label?: string;
  showEmail?: boolean;
  disabled?: boolean;
  onContinue: () => void;
}

const UploadActions: React.FC<Props> = (props: Props) => {
  const { disabled = false, complete, label, onContinue } = props;

  const handleContinueClick = () => {
    onContinue();
  };

  const getButtonProps = () => {
    if (complete) {
      return {
        label: 'Save & Continue',
        variant: 'solid',
      };
    }
    return {
      label: 'Return to document upload',
      variant: 'secondary',
    };
  };

  return (
    <Flex justifyContent="end" mt={10} mb={4}>
      <Button
        id={'save-doc-details-btn'}
        isDisabled={disabled}
        onClick={handleContinueClick}
        variant={getButtonProps().variant}
        size="lg"
      >
        {label ? label : getButtonProps().label}
      </Button>
    </Flex>
  );
};

export default UploadActions;
